import { render, staticRenderFns } from "./zoning-change-applied-for.vue?vue&type=template&id=73ba9bcc"
import script from "./zoning-change-applied-for.vue?vue&type=script&lang=js"
export * from "./zoning-change-applied-for.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports